exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-bold {\n  font-weight: 600;\n  font-size: 1rem;\n}\n.text-color {\n  font-size: 12px !important;\n  color: rgba(6, 38, 62, 0.84) !important;\n}\n\n/* #ocr-issue-modal .header-class-modal-doc-package h5 {\n\tcolor: #fff;\n} */\n", ""]);

// exports
